import Account from './account';

export default Account;